export default __webpack_public_path__ + "static/media/doc-toggler.53e451c2.svg";